module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/algoliasearch-helper/~/util/support/isBufferBrowser.js
 ** module id = 201
 ** module chunks = 0
 **/